// const originalFetch = window.fetch;

// window.fetch = async (url, options = {}) => {
//   const isGoogleRequest = url.includes("googleapis.com");

// const headers = {
//   ...(options.headers || {}),
// };

// if (!isGoogleRequest) {
//   const token = localStorage.getItem("token");

//   if (token) {
//     headers["Authorization"] = `Bearer ${token}`;
//   }
// }

//   const updatedOptions = {
//     ...options,
//     headers,
//   };

//   const response = await originalFetch(url, updatedOptions);

//   // 🚨 FIX: ignore 401 for auth endpoints
//   if (
//     response.status === 401 &&
//     !url.includes("googleapis.com") &&
//     !url.includes("/login") &&
//     !url.includes("/signup") &&
//     !url.includes("/forgot-password")
//   ) {
//     console.warn("Unauthorized → redirecting to login");
//     localStorage.removeItem("token");
//     window.location.href = "/";
//   }

//   return response;
// };

const originalFetch = window.fetch;

window.fetch = async (url, options = {}) => {
  const headers = {
    ...(options.headers || {}),
  };

  const hasAuthHeader = !!headers["Authorization"];

  const isGoogleApi = url.includes("googleapis.com");

  if (!hasAuthHeader && !isGoogleApi) {
    const token = localStorage.getItem("token");

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }

  const updatedOptions = {
    ...options,
    headers,
  };

  const response = await originalFetch(url, updatedOptions);

  if (
    response.status === 401 &&
    !url.includes("googleapis.com") &&
    !url.includes("/login") &&
    !url.includes("/signup") &&
    !url.includes("/forgot-password") &&
    !url.includes("/live/student-inbox/")
  ) {
    console.warn("Unauthorized → redirecting to login");
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  return response;
};